<script setup lang="ts">
withDefaults(defineProps<{
  pct: number
  tone?: 'normal' | 'warning' | 'danger'
  trackClass?: string
  dataAllowanceBarFill?: boolean
}>(), {
  tone: 'normal',
  trackClass: 'h-1 w-full bg-sidebar-hover',
  dataAllowanceBarFill: false,
})
</script>

<template>
  <div
    data-allowance-track
    class="overflow-hidden rounded-full"
    :class="trackClass"
  >
    <div
      data-allowance-fill
      data-allowance-bar-fill
      class="h-full rounded-full transition-all duration-300"
      :class="tone === 'danger' ? 'bg-destructive' : tone === 'warning' ? 'bg-destructive/80' : 'bg-muted-foreground'"
      :style="{ width: `${Math.max(0, Math.min(100, pct))}%` }"
    />
  </div>
</template>
